// extracted by mini-css-extract-plugin
export var section = "index-module--section--1eXc6";
export var logo_img = "index-module--logo_img--yM4Hr";
export var clouds_img = "index-module--clouds_img--1wQle";
export var clouds_pulse = "index-module--clouds_pulse--1a0vW";
export var clouds_move = "index-module--clouds_move--V1C_K";
export var title = "index-module--title--3LYIa";
export var socialMedia = "index-module--socialMedia--22LkD";
export var socialMedia_item = "index-module--socialMedia_item--3p-tq";